'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFlip = function MdFlip(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 35v-3.4h3.4c0 1.8-1.6 3.4-3.4 3.4z m0-13.4v-3.2h3.4v3.2h-3.4z m-6.6-13.2v-3.4h3.4v3.4h-3.4z m6.6 20v-3.4h3.4v3.4h-3.4z m-13.2 10v-36.8h3.2v36.8h-3.2z m13.2-33.4c1.8 0 3.4 1.6 3.4 3.4h-3.4v-3.4z m-26.6 3.4c0-1.8 1.6-3.4 3.4-3.4h6.6v3.4h-6.6v23.2h6.6v3.4h-6.6c-1.8 0-3.4-1.6-3.4-3.4v-23.2z m26.6 6.6v-3.4h3.4v3.4h-3.4z m-6.6 20v-3.4h3.4v3.4h-3.4z' })
        )
    );
};

exports.default = MdFlip;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/flip.js
// module id = 2867
// module chunks = 0